import { adminRequest } from "../../shared/api/client";
import type { AdminSteamAccount, AdminUserPage, DashboardData, GameDiagnostics, MiniProgramDisplay, SuggestionStatus, SyncStatus } from "../../shared/api/types";

export function loadDashboard() {
  return adminRequest<DashboardData>("/admin/dashboard");
}

export function loadSyncStatus() {
  return adminRequest<SyncStatus>("/admin/sync-status?limit=50");
}

export function loadMiniProgramDisplay() {
  return adminRequest<MiniProgramDisplay>("/admin/mini-program/display");
}

export function updateMiniProgramDisplay(showGameDetailVideo: boolean) {
  return adminRequest<MiniProgramDisplay>("/admin/mini-program/display", {
    method: "PUT",
    body: JSON.stringify({ showGameDetailVideo })
  });
}

export function updateSuggestionStatus(id: string, status: SuggestionStatus) {
  return adminRequest<{ id: string; status: SuggestionStatus }>(
    `/admin/dashboard-suggestions/${encodeURIComponent(id)}/status`,
    { method: "POST", body: JSON.stringify({ status }) }
  );
}

export function loadGameDiagnostics(appid: number) {
  return adminRequest<GameDiagnostics>(`/admin/games/${appid}/diagnostics`);
}

export function refreshGameDiagnostics(appid: number) {
  return adminRequest<{ appid: number; queued: boolean }>(`/admin/games/${appid}/refresh`, {
    method: "POST"
  });
}

export function loadUsers(page: number, pageSize: number, query = "") {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  if (query) params.set("query", query);
  return adminRequest<AdminUserPage>(`/admin/users?${params}`);
}

export function loadUserSteamAccounts(userId: string) {
  return adminRequest<{ items: AdminSteamAccount[] }>(
    `/admin/users/${encodeURIComponent(userId)}/steam-accounts`
  );
}
